import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "loyalty-redeem-configuration",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const loyaltyRedeemConfiguration =
            require("./LoyaltyRedeemConfiguration").default;
          cb(null, loyaltyRedeemConfiguration);
        },
        "LoyaltyRedeemOTP"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/LoyaltyRedeemConfiguration/index.js